<template>
    <div>
        <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

        <div v-if="(!errors && !loading && (items.length == 0))" class="alert alert-warning" role="alert">
            {{ $root.text('There are no languages', null, true) }}
        </div>
        <div v-if="(items.length > 0)" class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-5">{{ $root.text('Language', null, true) }}</div>
                                        <div class="col-3">{{ $root.text('Code', null, true) }}</div>
                                        <div class="col-3">{{ $root.text('Status', null, true) }}</div>
                                        <div class="col-1">&nbsp;</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row" :id="'language-row' + item.id" class="pb-0">
                                    <div class="row">
                                        <div class="col-5" style="padding-top: 3px">
                                            <h5 class="font-size-14 mb-0">
                                                <span v-if="item.default" class="text-dark">
                                                    {{ item.name }} {{ $root.text('(default)') }}
                                                </span>
                                                <a v-else href="#" class="text-dark" @click.prevent="toggleEditLanguage(item)">
                                                    {{ item.name }}
                                                </a>
                                            </h5>
                                        </div>
                                        <div class="col-3" style="padding-top: 3px">
                                            {{ item.code }}
                                        </div>
                                        <div class="col-3" style="padding-top: 3px">
                                            <span v-if="item.active">
                                                {{ $root.text('Active', null, true) }}
                                            </span>
                                            <span v-else>
                                                {{ $root.text('Inactive', null, true) }}
                                            </span>
                                        </div>
                                        <div class="col-1 font-size-18 contact-links">
                                            <a
                                                v-if="!item.default"
                                                href="#"
                                                class="float-right"
                                                @click.prevent="toggleEditLanguage(item)"
                                            >
                                                <span
                                                    v-if="(language_details_open.indexOf(item.id) < 0)"
                                                    :key="'close-' + item.id"
                                                >
                                                    <i class="fa-regular fa-chevron-circle-down"></i>
                                                </span>
                                                <span v-else :key="'open-' + item.id">
                                                    <i class="fa-regular fa-chevron-circle-up"></i>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row list-details-td mt-2">
                                        <div class="col-12 list-details" :id="'language-details' + item.id">
                                            <language-edit-form
                                                v-if="item.id > 1"
                                                :data="item"
                                                :is_visible="language_details_open.indexOf(item.id) > -1"
                                            ></language-edit-form>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div style="position: relative; top: -20px; height: 40px; overflow: visible">
            <loading v-if="loading"></loading>
        </div>

        <div
            class="modal fade"
            id="language-add-form-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="language-add-form-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <language-add-form></language-add-form>
            </div>
        </div>

        <div
            v-if="$root.hasPermission('content_edit')"
            class="modal fade"
            id="edit-content-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="edit-content-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <edit-content></edit-content>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                component_name: 'languages',
                loading: false,
                errors: false,
                items: [],
                language_details_open: []
            }
        },
        mounted () {
            $('body').removeClass('login-body');
            this.getLanguages();
        },
        methods: {
            getLanguages: function () {
                if (!this.$root.hasPermission('manage_languages')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.loading = true;
                this.errors = false;
                this.items = [];
                this.language_details_open = [];

                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/languages';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.items = response.data.languages;
                    vm.$root.languages = response.data.languages;
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            toggleEditLanguage: function (item) {
                if (this.language_details_open.indexOf(item.id) < 0) {
                    this.language_details_open.push(item.id);
                    $('#language-row' + item.id).addClass('highlighted');
                    $('#language-details' + item.id).slideDown('slow');
                } else {
                    var vm = this;
                    $('#language-details' + item.id).slideUp('slow', function () {
                        $('#language-row' + item.id).removeClass('highlighted');
                        for (var n = 0; n < vm.language_details_open.length; n++) { 
                            if (vm.language_details_open[n] == item.id) { 
                                vm.language_details_open.splice(n, 1); 
                            }
                        }
                    });
                }
            }
        }
    }
</script>
